import BaseModelFactory from './base.factory'
import ResourceTypeService from './../services/ResourceType.service'
import ResourceType from './../models/resource-type.model'

class ResourceTypeFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search({ search, pagination, order_by, method }, { Service: ResourceTypeService, Model: ResourceType })
  static findById = async id => await this._findById(id, { Service: ResourceTypeService, Model: ResourceType })
  static findAll = async () =>
    await this._search(
      { pagination: false, order_by: { rt_name: 'ASC' } },
      { Service: ResourceTypeService, Model: ResourceType }
    )
  static create = payload => this._create(payload, { Service: ResourceTypeService, Model: ResourceType })
}

export default ResourceTypeFactory
